import { render, staticRenderFns } from "./AttachIncident.vue?vue&type=template&id=ceec0214&"
import script from "./AttachIncident.vue?vue&type=script&lang=js&"
export * from "./AttachIncident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports